
import React, { Component } from "react";
// reactstrap components
import {
  CardBody,
  Card,
  Container,
  Row,
  Col,
  Badge
} from "reactstrap";
import { url } from 'inspector';

class Courses extends Component<any, any> {

  render() {
    return (
      <>
        <section className="py-4 pb-9 bg-default">
            <Container fluid>
              <Row className="justify-content-center text-center">
                <Col md="6">
                  <h2 className="display-3 text-white">
                    CÁC KHOÁ HỌC TẠI CCL MAGIC 
                  </h2>
                  <p className="lead text-white">
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg pt-lg-0 mt--7">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-compose-60`}></div>
                          </div>
                          <h4 className="h3 text-info text-uppercase">
                            UNLIMITED OFFLINE SYDNEY
                          </h4>
                          <ul className="list-unstyled mt-5">
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-settings-gear-65" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Luyện thi không giới hạn trong 4 Tháng
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-html5" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">Trang bị phương pháp, kĩ năng dịch thuật.</h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Review 1:1 Unlimited 
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    CCL PLATFORM: 150 Dialogues Mocktests, Từ vựng.
                                  </h4>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-training-60`}></div>
                          </div>
                          <h4 className="h3 text-success text-uppercase">
                            ONLINE INTENSIVE
                          </h4>
                          <ul className="list-unstyled mt-5">
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-settings-gear-65" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Lớp học Online Group trong 9 tuần. 
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-html5" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">Trang bị phương pháp, kĩ năng dịch thuật.</h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Review 1:1 Unlimited 
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    CCL PLATFORM: 150 Dialogues Mocktests, Từ vựng.
                                  </h4>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="mb-2">
                            <div className={`bg-icon-60 bg-topic-default bg-topic-rocket-60`}></div>
                          </div>
                          <h4 className="h3 text-warning text-uppercase">
                            CCL FIGHTER
                          </h4>
                          <ul className="list-unstyled mt-5">
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-settings-gear-65" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Khoá học CCL Cấp tốc & Offline
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-html5" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">Tập trung luyện Mock Test & Review</h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Phù hợp các bạn đã thi CCL nhưng chưa thành công hay đã có nền tảng cần ôn luyện thêm vững vàng. 
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    Review 1:1 Unlimited 
                                  </h4>
                                </div>
                              </div>
                            </li>
                            <li className="py-2">
                              <div className="d-flex align-items-center">
                                <div>
                                  <Badge
                                    className="badge-circle mr-3"
                                    color="success"
                                  >
                                    <i className="ni ni-satisfied" />
                                  </Badge>
                                </div>
                                <div>
                                  <h4 className="mb-0">
                                    CCL PLATFORM: 150 Dialogues Mocktests, Từ vựng.
                                  </h4>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
      </>
    )
  }
}

export default Courses;
